import React, { useState, useEffect } from 'react';
import { getEntityList, getGroupList } from '../../services/front_api';
import { updateStorage, getDefaultValue } from '../../services/storageManager'
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export default function EntityCombo({ application, category, source, name, label, onChange, setState, parentId, type = '', ...props }) {
    const [entities, setEntities] = useState([]);
    const [selectedEntitiesId, setSelectedEntitiesId] = useState(getDefaultValue(application, category, name) || []);
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const revalidateList = (data) => {
        var newSelectedEntitiesName = [];
        var newSelectedEntitiesId = [];
        selectedEntitiesId.map((entityId) => {
            const entity = data.find((entity) => entity.id === entityId);
            if (entity) {
                newSelectedEntitiesName.push(entity.label);
                newSelectedEntitiesId.push(entity.id);
            }
        })
        setSelectedEntitiesId(newSelectedEntitiesId);
        updateStorage(application, category, name, newSelectedEntitiesId);
        onChange(name, newSelectedEntitiesId)
        setState(true)
    }

    useEffect(() => {
        if (parentId && !parentId.length) {
            setEntities([]);
            setLoading(false);
            setDisabled(true);
            revalidateList([]);
        } else {
            setLoading(true);
            const fetchEntities = async () => {
                try {
                    var data
                    if (source === 'group') {
                        data = await getGroupList(parentId, type);
                    } else {
                        data = await getEntityList(parentId, type);
                    }
                    setEntities(data);
                    setDisabled(false);
                    revalidateList(data);
                } catch (err) {
                    setError('Erreur lors de la récupération des entités');
                } finally {
                    setLoading(false);
                }
            };
            fetchEntities();
        }
    }, [parentId, type]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;

        var listId = typeof value === 'string' ? value.split(',') : value
        setSelectedEntitiesId(listId);
        updateStorage(application, category, name, listId);
        onChange(name, listId)
        setState(true)
    };

    const RenderSelectedArea = (vals) => {
        var newSelectedEntitiesName = [];
        var newSelectedEntitiesId = [];
        vals.map((entityId) => {
            const entity = entities.find((entity) => entity.id === entityId);
            if (entity) {
                newSelectedEntitiesName.push(entity.label);
                newSelectedEntitiesId.push(entity.id);
            }
        })
        return newSelectedEntitiesName.join(', ')
    }

    return (
        <div {...props}>
            <FormControl sx={{ m: 1, width: 300 }} disabled={disabled} variant="outlined">
                <InputLabel id={`entity-combo-label-${type}`}>{label}</InputLabel>
                <Select
                    labelId={`entity-combo-label-${type}`}
                    id={`entity-combo-${type}`}
                    multiple
                    value={selectedEntitiesId}
                    onChange={handleChange}
                    input={<OutlinedInput label={label} />}
                    renderValue={RenderSelectedArea}
                    MenuProps={MenuProps}
                >
                    {entities.map((entity) => (
                        <MenuItem key={`${label}_${entity.id}`} value={entity.id}>
                            <Checkbox checked={selectedEntitiesId.includes(entity.id)} />
                            <ListItemText primary={entity.label} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
}
